import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { OwnMembership } from './types';

import { apiRequest, type ApiError } from '@/lib/api-client';
import { useSession } from '@/lib/session';

/**
 * `GET /api/v1/auth/me/memberships` — built this lot (OQ-23) specifically
 * so this frontend has a real, non-invented way to learn which shop(s) the
 * signed-in user belongs to. No `X-Shop-Id` needed for this one call — it
 * predates shop selection by construction.
 */
export function useMyMembershipsQuery(): UseQueryResult<readonly OwnMembership[], ApiError> {
  const { accessToken } = useSession();
  return useQuery({
    queryKey: ['me', 'memberships'],
    queryFn: () => apiRequest<readonly OwnMembership[]>('/auth/me/memberships', { accessToken }),
    enabled: accessToken !== null,
    staleTime: 60_000,
  });
}
